module.exports = __webpack_public_path__ + "static/media/SKInteracEng.5e2bfccb.png";